var CustomScreenModel = require("../models/CustomScreenModel");
var AbstractWS = require("./AbstractWS");
var xmlToJson = require("../helpers/xmlToJson");

function CustomScreensWS(parent) {
  var self = this;

  AbstractWS.apply(self, arguments);

  self.allScreens = ko.observableArray([]);
  self.inited = false;
  self.name = 'CustomScreensWS';

  /**
   * API Endpoint
   * 
   * @method serviceURL
   * @returns {String}
   */
  self.serviceURL = ko.computed(function () {
    return '/qless/api/v1/kiosk/location/' + parent.id + '/customScreens';
  });


  /**
   * Prototype override
   * 
   * @method doRequest
   * @returns none
   */
  self.doRequest = function (fCallback) {
    if (!self.inited) {
      AbstractWS.prototype.doRequest.call(self, fCallback);
    }
  };


  /**
   * Determines the custom screens available to the user
   * If a transaction type has been selected, only screens that match that
   * transaction type id or have none will be returned.
   * 
   * Also sets the kiosk.customScreen variable if it is currently not set
   * (bad separation of concern)
   * 
   * @method screens
   * @returns {Array | Null}
   */
  self.screens = ko.computed(function () {
    return null;
    //var transType = (kiosk) ? kiosk.selectedTransactionType() : null;

    // If there is no kiosk and no selected transaction type, just return
    // all the screens
    // if (!(kiosk && transType)) {
    //   retScreens = self.allScreens();
    // }
    // If there is a kiosk AND a transaction type, return the screens that
    // match that transaction type id
    // else {
    //   retScreens = self.getScreensByTransactionTypeId(transType.id);
    // }

    // If there is not a custom screen loaded up, make sure one is loaded when we get to the
    // custom screen interface
    // if (kiosk) {
    //   if (kiosk.page() == 'customScreens' && retScreens.indexOf(kiosk.customScreen()) == -1 && kiosk.customScreen() == null) {
    //     kiosk.customScreen(retScreens[0] || null);
    //   }
    // }
  });


  /**
   * Returns a collection of screens that correspond to the
   * Transaction Type ID
   * 
   * @method getScreensByTransactionTypeId
   * @param {Number} id
   * @returns {Array}
   */
  self.getScreensByTransactionTypeId = function (id) {
    return self.allScreens().filter(function (s) {
      return s.transactionTypeId == id || s.transactionTypeId == null
    });
  };


  /**
   * Converts data from the API return into CustomScreenModels
   * 
   * @method processData
   * @param {XMLDocument} data
   * @returns none
   */
  self.processData = function (data) {
    self.allScreens.removeAll();
    self.inited = true;

    AbstractWS.prototype.processData.call(self, data);

    if (data) {
      var json = xmlToJson.parse(data);

      if (json) {
        var screens = json.customKioskScreens.screen;

        if (screens instanceof Array === false && screens instanceof Object === true) {
          screens = [screens];
        }

        if (screens && screens.length > 0) {
          screens.forEach(function (screen) {
            if (screen.hidden !== true) {
              self.allScreens.push(new CustomScreenModel(screen, self.parent.kioskMessagesWS));
            }
          });
        }
      }
    }
  };


  /**
   * Calls all associated CustomScreenModels to reset their fields to null
   *
   * @method resetCustomScreenFields
   * @returns none
   */
  self.resetCustomScreenFields = function () {
    self.allScreens().forEach(function (screen) {
      screen.resetFields();
    });
  };

  return self;

};

CustomScreensWS.prototype = AbstractWS.prototype;
CustomScreensWS.prototype.constructor = CustomScreensWS;

module.exports = CustomScreensWS
